import React from 'react';
import { Space } from 'antd';
import { GranularitySelect } from '@src/components/common';
import { useDispatch, useSelector } from 'react-redux';
import { intervalSelector } from '@src/store/common/selectors';
import { updateGranularity } from '@store/common/actions';
import CompareWarning from './CompareWarning';

function GranularityControl() {
  const dispatch = useDispatch();
  const interval = useSelector(intervalSelector);

  const handleGranularityChange = (value) => {
    dispatch(updateGranularity(value));
  };

  return (
    <Space>
      <CompareWarning />
      <GranularitySelect updateGranularity={handleGranularityChange} interval={interval} />
    </Space>
  );
}

export default GranularityControl;
